export default __webpack_public_path__ + "static/home_refinance-0a82a98c3891134436699eac1aea0f02.svg";